import LoginPage from '@Pages/LoginPage/LoginPage';
import ContactPage from '@Pages/ContactPage/ContactPage';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { featureESSRouter, featureMRRouter } from '@Features/router';
import ProtectedPage from '@Pages/ProtectedPage/ProtectedPage';
import MaintenancePage from '@Pages/MaintenancePage/MaintenancePage';
import { ErrorPage } from '@Pages/ErrorPage';
import { ErrorPageTypes } from '@Enum/ErrorPageTypes.enum';
import App from '../App';
import BaseRoutePath from './baseRoutePathes.enum';

type RouterType = ReturnType<typeof createBrowserRouter>;

const getRouter = (): RouterType => {
  return createBrowserRouter([
    {
      path: BaseRoutePath.HOME,
      element: (
        <ProtectedPage>
          <App />
        </ProtectedPage>
      ),
      errorElement: <Navigate to={BaseRoutePath.ERROR} replace />,
      children: [
        ...featureESSRouter,
        ...featureMRRouter,
        {
          path: BaseRoutePath.CONTACTS.substring(1), // Remove leading slash for child route
          element: <ContactPage />,
        },
      ],
    },
    {
      path: BaseRoutePath.ERROR,
      element: <ErrorPage type={ErrorPageTypes.SOMETHING_WENT_WRONG} />,
    },
    {
      path: BaseRoutePath.NOT_FOUND,
      element: <ErrorPage type={ErrorPageTypes.NOT_FOUND} />,
    },
    {
      path: BaseRoutePath.NO_ACCESS,
      element: <ErrorPage type={ErrorPageTypes.FORBIDDEN} />,
    },
    {
      path: BaseRoutePath.ACCESS_FORBIDDEN,
      element: <ErrorPage type={ErrorPageTypes.ACCESS_FORBIDDEN} />,
    },
    {
      path: BaseRoutePath.LOGIN,
      element: <LoginPage />,
    },
    {
      path: BaseRoutePath.MAINTENANCE,
      element: <MaintenancePage />,
    },
    {
      path: BaseRoutePath.ANY,
      element: <Navigate to={BaseRoutePath.NOT_FOUND} replace />,
    },
  ]);
};

export default getRouter;
